import type { ReservationAuditLog } from './types';

export function modificationsOf(
  history: ReservationAuditLog[] | null | undefined,
): ReservationAuditLog[] {
  return (history ?? [])
    .filter(log => log.action === 'MODIFIED')
    .sort((a, b) => b.date_created.localeCompare(a.date_created));
}

/*
 * Returns who made the latest modification (PARTNER | CLIENT),
 * or an empty string if the reservation was never modified.
 */
export function lastModifiedBy(
  history: ReservationAuditLog[] | null | undefined,
): string {
  return modificationsOf(history)[0]?.actor_type || '';
}
